import React from "react";
import {
  CommonsStore,
  GoBackButton,
  I18n,
  IndexView,
  LocalListDataSource,
  OneViewProps,
  PopupMessage
} from "lego-gui-lib";

export interface ReportComponentState {
  data: any[];
}

export interface ReportComponentProps<T, ID> extends OneViewProps<T, ID> {
  id: ID;
  customButtons?: any;
  deleteMessage?: PopupMessage;
  commons: CommonsStore;
  i18n?: I18n;
}

export class ReportComponent<T extends object, ID> extends React.Component<
  ReportComponentProps<T, ID>,
  ReportComponentState
> {
  public constructor(props: ReportComponentProps<T, ID>) {
    super(props);
    this.state = {
      data: []
    };
  }

  public componentDidMount() {
    this.props.dataSource.clear();
    this.props.dataSource.findOne(this.props.id).then((response: any) => {
      this.createReportData(response.reportInfo);
    });
  }

  private timeNow = (i: number) => {
    const time = new Date();
    time.setHours(i);
    time.setMinutes(0);
    time.setSeconds(0);
    return time.toLocaleTimeString("en-GB", {
      hour: "2-digit",
      minute: "2-digit"
    });
  };

  private createReportData(reportInfo: any) {
    const data = reportInfo.hourly.map((hourly: any) => {
      const time = this.timeNow(hourly.from) + " - " + this.timeNow(hourly.to);
      const d = hourly.data;
      d.time = time;
      return d;
    });
    const total = reportInfo.total;
    total.time = "Total";
    data.unshift(total);
    this.setState({ data: data });
  }

  private getDataSource = () => {
    const newDataSource = new LocalListDataSource({
      name: "reports",
      schema: this.props.fields,
      commons: this.props.commons,
      source: this.state.data
    });
    newDataSource.total = this.state.data.length - 1;

    return newDataSource;
  };

  private getTitleContainer = ({ children }: any) => {
    return (
      <div>
        <div style={{ float: "left", marginRight: "5px" }}>
          <GoBackButton />
        </div>
        <div>{children}</div>
      </div>
    );
  };

  public render() {
    const {
      title,
      fields,
      dataSource,
      customButtons,
      id,
      ...rest
    } = this.props;
    return this.state.data.length ? (
      // @ts-ignore
      <IndexView
        {...rest}
        dataSource={this.getDataSource()}
        titleButtons={() => customButtons}
        title={title}
        toolbarButtons={[]}
        rowButtons={[]}
        columns={fields}
        // @ts-ignore
        disableCheckboxes={true}
        titleContainer={this.getTitleContainer}
        // @ts-ignore
        hidePageable={true}
        // @ts-ignore
        hideTotalPages={true}
        alignCellText={"right"}
      />
    ) : (
      <></>
    );
  }
}
export class MonthlyReportComponent<
  T extends object,
  ID
> extends React.Component<ReportComponentProps<T, ID>, ReportComponentState> {
  public constructor(props: ReportComponentProps<T, ID>) {
    super(props);
    this.state = {
      data: []
    };
  }

  public componentDidMount() {
    this.props.dataSource.clear();
    this.props.dataSource.findOne(this.props.id).then((response: any) => {
      this.createReportData(response.reportInfo);
    });
  }

  private createReportData(reportInfo: any) {
    const data = Object.values(reportInfo.daily).map((daily: any) => {
      const d = daily.data;
      d.time = `Day ${daily.day}`;
      return d;
    });

    const total = reportInfo.total;
    total.time = "Total";
    data.unshift(total);

    this.setState({ data });
  }

  private getDataSource = () => {
    const newDataSource = new LocalListDataSource({
      name: "reports",
      schema: this.props.fields,
      commons: this.props.commons,
      source: this.state.data
    });
    newDataSource.total = this.state.data.length - 1;

    return newDataSource;
  };

  private getTitleContainer = ({ children }: any) => {
    return (
      <div>
        <div style={{ float: "left", marginRight: "5px" }}>
          <GoBackButton />
        </div>
        <div>{children}</div>
      </div>
    );
  };

  public render() {
    const {
      title,
      fields,
      dataSource,
      customButtons,
      id,
      ...rest
    } = this.props;
    return this.state.data.length ? (
      <IndexView
        {...rest}
        dataSource={this.getDataSource()}
        titleButtons={() => customButtons}
        title={title}
        toolbarButtons={[]}
        rowButtons={[]}
        columns={fields}
        //@ts-ignore
        disableCheckboxes={true}
        titleContainer={this.getTitleContainer}
        //@ts-ignore
        hidePageable={true}
        //@ts-ignore
        hideTotalPages={true}
        alignCellText={"right"}
      />
    ) : (
      <></>
    );
  }
}
